<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="card-checklist" class="icon"></b-icon>
            <span>รายการบัญชี</span>
        </div>

        <div class="content">
            <div class="filter form mb-4">
                <accounting-filter @lookup="filterAccountingList($event)"></accounting-filter>
            </div>

            <div class="mb-4 text-right" v-if="bookNumber === 1">
                <button class="btn btn-main" @click="openAccountingForm('')">เพิ่มรายการบัญชี</button>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>วันที่ทำรายการ</th>
                            <th>รายการ</th>
                            <th class="text-center">รายรับ</th>
                            <th class="text-center">รายจ่าย</th>
                            <th class="text-center">ภาษี</th>
                            <th class="text-center">อ้างอิง</th>
                            <th v-if="bookNumber === 1"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in accountingList.filter(x => x.bookNumber === bookNumber)" :key="index">
                            <td class="text-center text-nowrap">
                                <button class="icon" @click="openAccountingForm(item.key)"><b-icon icon="pencil"></b-icon></button>
                                <button class="icon" @click="deleteAccounting(item.data)"><b-icon icon="trash"></b-icon></button>
                            </td>
                            <td>{{ item.date }}</td>
                            <td v-html="item.title"></td>
                            <td class="text-center">{{ item.revenue }}</td>
                            <td class="text-center">{{ item.expense }}</td>
                            <td class="text-center">{{ item.tax }}</td>
                            <td class="text-center">
                                <template v-if="item.reference">
                                    <a :href="item.reference" target="_blank">LINK</a>
                                </template>
                            </td>
                            <td class="text-center" v-if="bookNumber === 1">
                                <button class="btn btn-sm btn-blue" v-if="item.isClonable" @click="cloneToSecondBook(item.data)">คัดลอกไปที่เล่ม 2</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="accountingList.filter(x => x.bookNumber === bookNumber).length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่พบรายการบัญชี</span>
            </div>

            <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="accountingList.filter(x => x.bookNumber === bookNumber).length" class="mt-4"></paging>
        </div>

        <accounting-modal-form :isDisplay="isShowAccountingForm" :keyData="accountingKeyId" @hide="closeAccountingForm($event)"></accounting-modal-form>
    </div>
</template>

<script>
import AccountingFilter from '@/components/accounting/Filter';
import AccountingModalForm from '@/components/accounting/ModalForm';
import Helper from '@/resources/Helper';
import DBAccounting from '@/database/Accounting';
import ModelAccountingFilter from '@/resources/models/AccountingFilter';

export default {
    components: {
        AccountingFilter,
        AccountingModalForm
    },
    data() {
        return {
            isShowAccountingForm: false,
            accountingKeyId: '',
            accountingList: [],
            accountingFilter: ModelAccountingFilter.data(),
            isLoading: false,
            pageSize: 20,
            activePage: 1
        }
    },
    props: {
        bookNumber: Number
    },
    mounted() {
        this.loadAccountingList();
    },
    methods: {
        openAccountingForm(key) {
            this.accountingKeyId = key;
            this.isShowAccountingForm = true;
        },
        closeAccountingForm(isReload) {
            this.isShowAccountingForm = false;

            if (isReload) {
                this.loadAccountingList();
            }
        },
        filterAccountingList(value) {
            this.accountingFilter = value;
            this.loadAccountingList();
        },
        filterResult(result) {
            if (this.accountingFilter.keyword) {
                result = result.filter(x => x.title?.toLowerCase().indexOf(this.accountingFilter.keyword.toLowerCase()) > -1)
            }
            if (this.accountingFilter.createDateFrom) {
                const filterDate = this.accountingFilter.createDateFrom;
                filterDate.setHours(0, 0, 0, 0);

                result = result.filter(x => x.date.getTime() >= filterDate.getTime())
            }
            if (this.accountingFilter.createDateTo) {
                const filterDate = this.accountingFilter.createDateTo;
                filterDate.setHours(23, 59, 59, 0);

                result = result.filter(x => x.date.getTime() <= filterDate.getTime())
            }
            if (this.accountingFilter.revenueFrom) {
                result = result.filter(x => parseFloat(x.revenue) >= parseFloat(this.accountingFilter.revenueFrom));
            }
            if (this.accountingFilter.revenueTo) {
                result = result.filter(x => parseFloat(x.revenue) <= parseFloat(this.accountingFilter.revenueTo));
            }
            if (this.accountingFilter.revenueFrom) {
                result = result.filter(x => parseFloat(x.revenue) >= parseFloat(this.accountingFilter.revenueFrom));
            }
            if (this.accountingFilter.revenueTo) {
                result = result.filter(x => parseFloat(x.revenue) <= parseFloat(this.accountingFilter.revenueTo));
            }

            return result;
        },
        async loadAccountingList() {
            this.isLoading = true;
            this.accountingList = [];
            const result = await DBAccounting.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Place into the Object
                this.accountingList = this.mapViewData(result.content);
            }

            this.isLoading = false;
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    key: item.key,
                    date: this.$AppUtility.displayTimeFormat(item.date),
                    title: item.title,
                    revenue: item.revenue ? Helper.getCommaNumber(parseFloat(item.revenue).toFixed(2)) : '',
                    expense: item.expense ? Helper.getCommaNumber(parseFloat(item.expense).toFixed(2)) : '',
                    tax: item.tax ? Helper.getCommaNumber(parseFloat(item.tax).toFixed(2)) : '',
                    reference: item.reference,
                    isClonable: item.isClonable,
                    bookNumber: item.bookNumber,
                    data: item
                });
            });

            return data;
        },
        deleteAccounting(item) {
            this.$swal({
                title: 'ลบลูกค้ารายการบัญชี?',
                text: 'โปรดยืนยันว่าต้องการลบรายการบัญชีที่เลือก',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    await DBAccounting.delete(item);

                    this.loadAccountingList();
                    loader.hide();
                }
            });
        },
        async cloneToSecondBook(item) {
            const loader = this.$AppUtility.renderLoadBackdrop();

            // Clone to Book 2
            const book2 = {
                key: '',
                date: item.date,
                title: item.title,
                revenue: item.revenue ? Helper.getCommaNumber(parseFloat(item.revenue).toFixed(2)) : '',
                expense: item.expense ? Helper.getCommaNumber(parseFloat(item.expense).toFixed(2)) : '',
                tax: item.tax ? Helper.getCommaNumber(parseFloat(item.tax).toFixed(2)) : '',
                reference: item.reference,
                bookNumber: 2,
                originalBook: item.key,
                isClonable: false
            };
            
            await DBAccounting.save(book2);

            // Update Clone Book 1
            const book1 = await DBAccounting.getDetail(item.key);      
            book1.isClonable = false;

            await DBAccounting.save(book1);

            // Done
            this.$swal({
                title: 'คัดลอกรายการบัญชีเรียบร้อยแล้ว',
                icon: 'success'
            });

            // Reload
            this.loadAccountingList();
            loader.hide();
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>